import { render } from "./FeedbackDisplayPage.vue?vue&type=template&id=19961e82&scoped=true"
import script from "./FeedbackDisplayPage.vue?vue&type=script&lang=js"
export * from "./FeedbackDisplayPage.vue?vue&type=script&lang=js"

import "./FeedbackDisplayPage.vue?vue&type=style&index=0&id=19961e82&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19961e82"]])

export default __exports__